import Swiper from "swiper";
import 'swiper/css';

export default class TeamSwiper {
    constructor() {
        const wrapper = document.querySelectorAll('.team-member-slider-widget__wrapper');

        if (!wrapper.length) {
            return;
        }
        
        wrapper.forEach((wrap) => {
            const teamSwiper = new Swiper('.team-members-swiper', {
                loop: true,
                slidesPerView: 3.5,
                spaceBetween: 30,
                grabCursor: true,

                breakpoints: {
                    0: {
                        slidesPerView: 1, 
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3.5,  
                        spaceBetween: 30,
                    },
                }
            });
        }); 
    } 
} 
